export default "__VITE_ASSET__CXcFxOEw__"